<template>
  <CompanyWrapper>
    <CommonQuestion></CommonQuestion>
  </CompanyWrapper>
</template>

<script>
import CompanyWrapper from "../../../../components/pc/company/CompanyWrapper";
import CommonQuestion from "../../../../components/pc/faq/CommonQuestion";
export default {
  components: {
    CompanyWrapper,
    CommonQuestion,
  },
  name: "Question",
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/pc/company/faq/Question.vue